import type { SupportDialogProps } from './support-dialog.types.ts';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import logo from '../assets/logo.png';
import styles from './support-dialog.module.scss';

export function SupportDialog({ onClose }: SupportDialogProps) {
  return (
    <Dialog
      title={
        <div className={styles.dialogTitle}>
          <FontAwesomeIcon icon={faQuestionCircle} className={styles.icon} />
          <span>Help & Support</span>
        </div>
      }
      className={styles.window}
      onClose={onClose}
    >
      <div className={styles.content}>
        <div className={styles.logoContainer}>
          <img src={logo} alt={'Logo'} />
        </div>
        <div className={styles.infoContainer}>
          <span>Sampling Analytics Dashboard</span>
          <span>
            For assistance or to report issues with this tool, please get in touch with the SoilEssentials Development
            Team.
          </span>
        </div>
      </div>
      <DialogActionsBar layout={'end'}>
        <div className={styles.actionButtonGroup}>
          <Button onClick={onClose}>Close</Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
}
